import { Link } from 'react-router-dom';
import { ArrowRight, Briefcase } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function Careers() {
  return (
    <div className="relative overflow-hidden">
      <section className="py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-africa-green mb-3 flex items-center justify-center gap-2">
            <Briefcase className="w-4 h-4" aria-hidden />
            Academy
          </p>
          <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
            Careers at Homeland
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed mb-10">
            We are growing a team of educators, operators, and builders who care deeply about African
            innovation. Open roles and partnerships are shared here as they become available.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Button
              asChild
              size="lg"
              className="bg-accent text-accent-foreground hover:bg-gold-light rounded-xl"
            >
              <Link to="/contact">
                Express interest <ArrowRight className="w-5 h-5 ml-1 inline" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="rounded-xl">
              <Link to="/courses">View programs</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
